import ActionType from 'store/actionTypes';
import moment from 'moment';
import {IAction, IState} from './types';
import {FacilityKey} from 'enums';

const initialState: IState = {
  list: [],
  date: moment().format('YYYY-MM-DD'),
  facility: FacilityKey.CQ,
};

export default function publicEventsReducer(state: IState = initialState, action: IAction) {
  switch (action.type) {
    case ActionType.GET_PUBLIC_EVENTS_SUCCESS:
      return {
        ...state,
        list: action.data?.list,
        date: action.data?.date,
        facility: action.data?.facility,
      };

    case ActionType.UPDATE_PUBLIC_EVENTS_SUCCESS:
      const updatedList = action.data?.list ?? [];
      if (!updatedList.length) {
        return state;
      }

      const index = state.list.findIndex((e) => e.event.id === updatedList[0].event.id);
      return {
        ...state,
        list: [...state.list.filter((e) => e.event.id !== updatedList[0].event.id), {...updatedList[0], index}],
      };

    default:
      return state;
  }
}
